import {Point} from '@postermywall/fabricjs-2';
import type {TPointerEvent} from '@postermywall/fabricjs-2';

/** Where a mouse, pointer or touch event happened on screen; a touch reports its first changed touch. */
export const getPointerClientPoint = (event: TPointerEvent): Point => {
  const source = 'changedTouches' in event ? event.changedTouches[0] : event;
  return new Point(source.clientX, source.clientY);
};
